import Cookie from 'js-cookie'

export default function guest({ next }) {
  const authToken = Cookie.get('_pup_access_token')
  const newUser = localStorage.getItem('_pup_new_user')
  // const authUser = Cookie.get('_pup_user')

  if (authToken && newUser) {
    return next()
  } else {
    return next({ name: 'Dashboard' }).catch(() => {})
  }
}
